<template>
  <VDialogV3
    id="demand-edit-buyer-info-dialog"
    position="right"
    width="600px"
    height="100vh"
    :loading="false"
    title="Редактирование данных покупателя"
    @submit="onSubmit"
  >
    <section>
      <VSelect
        v-model="localBaseDemand.buyer"
        label="Покупатель"
        layout="vertical"
        required
        disabled
      />

      <VSelect
        v-model="localBaseDemand.buyerCompany"
        label="Юр. лицо"
        layout="vertical"
        required
        :options="localBaseDemand.buyer.companies"
      />

      <VSelect
        v-model="localBaseDemand.buyerStore"
        label="Склад доставки"
        layout="vertical"
        required
        :options="localBaseDemand.buyer.stores"
      />

      <VSelect
        v-model="localBaseDemand.buyerProductionSite"
        label="Производственная площадка"
        layout="vertical"
        :options="localBaseDemand.buyerCompany.productionSites"
      />
    </section>

    <hr>

    <section>
      <VSelect
        v-model="localBaseDemand.responsibleBuyer"
        label="Ответственный"
        layout="vertical"
        required
        :search-function="pattern => PersonsService.searchPersons(pattern, localBaseDemand.buyer.id)"
      />
    </section>

    <hr>

    <div>
      <VHelperText icon="attention">
        Редактирование этих полей изменит данные у всех позиций товаров в потребности.
      </VHelperText>
    </div>
  </VDialogV3>
</template>

<script lang="ts">

import Core           from '@/core/Core';
import PersonsService from '@/domains/Persons/PersonsService';
import Demand         from '@/domains/Demand/Demand';

import VHelperText from '@/lib/components/VHelperText/VHelperText.vue';

export default defineComponent({
  name: 'DemandBuyerRequisitesDialog',

  components: { VHelperText },

  props: {
    baseDemand: {
      type:    Object as PropType<Demand>,
      default: null,
    },
  },

  emits: ['close', 'save'],

  data() {
    return {
      PersonsService,
      localBaseDemand: Core.utils.cloneDeep(this.baseDemand) as Demand,
    };
  },

  methods: {
    /** Применяет изменения (VDialogV3 уже провалидировал форму) и закрывает диалог */
    onSubmit(): void {
      this.$emit('save', this.localBaseDemand);
      this.$core.dialogs.DemandBuyerRequisitesDialog.hide();
    },
  },
});
</script>
